<template>
  <a-modal :visible="showDialog" width="80%" :mask="true" :maskClosable="false" title="产品权限申请" @cancel="handleCancel()" okText="提交">
    <a-form layout="inline">
      <!-- <a-form-item label="选择产品（可多选）：">
        <a-select v-model="product" style="width: 400px" allowClear
                      mode="multiple" :maxTagCount="1" placeholder="请选择产品（可多选）"
                      optionFilterProp="label">
              <a-select-option v-for="productItem in $store.getters.getAppAll"
                              :label="productItem.app_name"
                              :value="productItem.app_id"
                              :key="productItem.app_id">
                {{productItem.app_name}}
              </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="选择审批人：">
        <a-select v-model="user" style="width: 400px" allowClear
         :maxTagCount="1" placeholder="请选择审批人"
                      optionFilterProp="label">
              <a-select-option v-for="userItem in reviewUser"
                              :label="userItem.name"
                              :value="userItem.id"
                              :key="userItem.id">
                {{userItem.name}}
              </a-select-option>
        </a-select>
      </a-form-item> -->
      <a-row>
        <a-col :span="12">
          <a-form-item>
            <a-radio-group v-model="platform" button-style="solid" @change="onChange">
              <a-radio-button value="">
                ALL
              </a-radio-button>
              <a-radio-button value="ios">
                <a-icon type="apple" />
              </a-radio-button>
              <a-radio-button value="android">
                <a-icon type="android" />
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item>
            <a-radio-group v-model="isHas" button-style="solid">
              <a-radio-button :value="0">
                全部
              </a-radio-button>
              <a-radio-button :value="1">
                拥有
              </a-radio-button>
              <a-radio-button :value="2">
                未授权
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <a-input v-model="name" allowClear placeholder="产品/应用名称" @pressEnter="onChange">
              <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
            </a-input>
            <!-- <a-button icon="search" @click="onChange()"></a-button> -->
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" style="margin-top: 10px;max-height:50vh;overflow-y: scroll;">
        <a-col :span="8" :key="dataIndex"
               v-if="checkShow(dataItem.app_id)"
               v-for="(dataItem, dataIndex) in dataList" style="margin-bottom: 10px;"
          @click="saveDo(dataItem)">
          <div class="card">
            <div class="corner" v-if="$store.state.UserInfo.app.includes(dataItem.app_id)"></div>
            <div class="corner_text" v-if="$store.state.UserInfo.app.includes(dataItem.app_id)">已授权</div>
            <a-avatar :src="dataItem.icon" style="min-width:32px;height:32px" />
            <a-tooltip style="cursor: pointer" >
              <template slot="title" >
                {{dataItem.product_name}}
              </template>
              <span class="card_content">
                {{ dataItem.product_name }}
              </span>
            </a-tooltip>
            <a-icon style="font-size: 20px;" :type="dataItem.platform === 'ios' ? 'apple' : 'android'" />
          </div>
        </a-col>
      </a-row>

    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
    </template>

  </a-modal>
</template>
<script>
import { ApplyDo, GetAppList } from "../../api/v1/app_api";

export default {
  name: "ApplyDialog",
  props: ['reviewUser', 'appList', 'showDialog'],
  data() {
    return {
      dataList: this.appList,
      product: [],
      user: '',
      platform: '',
      name: '',
      loading: false,
      isHas:0,
    }
  },
  watch: {
    appList: {
      handler(newVal, oldVal) {
        this.dataList = newVal
      }
    }
  },
  computed:{

  },
  methods: {
    checkShow(app_id){
      if (!this.isHas){
        return true;
      }
      let _a = this.isHas===1?1:-1;
      let _b = this.$store.state.UserInfo.app.includes(app_id)?1:-1
      return _a*_b===1;
    },
    saveDo(item) {
      if (this.loading) {
        this.$message.info('请不要重复操作')
        return
      }
      this.loading = true
      var that = this
      let apps = []
      apps.push(item.app_id)
      this.$confirm({
        title: '是否申请 ' + item.app_name + ' 的产品权限',
        centered: true,
        onOk() {
          ApplyDo({ "appIds": apps }).then(resp => {
            if (resp.code === 200) {
              that.$message.success('申请成功')
              that.product = []
              that.user = ''
            } else {
              that.$message.error(resp.msg)
            }
          }).finally(() => {
            that.loading = false
          })
        },
        onCancel() {
          that.loading = false
        },
        class: 'test',
      });
    },
    onChange() {
      GetAppList({ platform: this.platform, name: this.name }).then(resp => {
        if (resp.code === 200) {
          this.dataList = resp.data
        }
      })
    },
    handleCancel() {
      this.loading = false
      this.product = []
      this.user = ''
      this.$emit('close-dialog')
    },
  }
}
</script>

<style scoped>
.card {
  border: 1px solid #787878;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background-color: #fafafa;
}

.corner {
  position: absolute;
  right: 0;
  top: 0;
  border-color: transparent #1890ff;
  border-width: 0 45px 45px 0;
  border-style: solid;
  text-align: center
}

.corner_text {
  position: absolute;
  right: 0;
  top: 8px;
  transform: rotate(45deg);
  font-size: 12px;
  color: #eee;
}

.card_content {
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/V1/ApplyDialog.vue